"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performance = performance;

// 通过performance记录页面加载时间段
function performance() {
  var performanceRecord = {};

  if (window.performance && window.performance.timing) {
    var timing = window.performance.timing;
    performanceRecord = {
      appCacheTimer: timing.domainLookupStart - timing.fetchStart,
      dnsTimer: timing.domainLookupEnd - timing.domainLookupStart,
      tcpTimer: timing.connectEnd - timing.connectStart,
      requestTimer: timing.responseEnd - timing.responseStart,
      domTimer: timing.domComplete - timing.domInteractive,
      pageEmptyTimer: timing.responseStart - timing.navigationStart,
      domReadyTimer: timing.domContentLoadedEventEnd - timing.navigationStart,
      onloadTimer: timing.loadEventEnd - timing.navigationStart,
      onloadNative: Date.now() - timing.navigationStart
    };
  }

  return performanceRecord;
}